import { render } from "./ObjectConfig.vue?vue&type=template&id=679f42f8&ts=true"
import script from "./ObjectConfig.vue?vue&type=script&lang=ts"
export * from "./ObjectConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__